import { v4 } from 'uuid';

var requestId = function() {
    return v4();
};
var correlationId = function() {
    return v4();
};

export { correlationId, requestId };
